export const rapidRecon = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 21,
  inputPaddingInline: 15,

  inputHeight: 63,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Raleway", sans-serif',
  inputColor: "#1A1818",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#96999C",
  inputBorderWidth: 1,
  inputBorderRadius: 8,

  inputHoverColor: "#1A1818",
  inputHoverBorderColor: "#96999C",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 21,
  selectPaddingInline: 15,

  selectHeight: 63,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Raleway", sans-serif',
  selectColor: "#1A1818",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 700,

  selectBorderColor: "#96999C",
  selectBorderWidth: 1,
  selectBorderRadius: 8,

  selectHoverColor: "#1A1818",
  selectHoverBorderColor: "#96999C",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 21,
  textAreaPaddingInline: 15,

  textAreaHeight: 75,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Raleway", sans-serif',
  textAreaColor: "#1A1818",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#96999C",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 8,

  textAreaHoverColor: "#1A1818",
  textAreaHoverBorderColor: "#96999C",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#1A1818",
  placeholderFontFamily: '"Raleway", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#1A1818",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 13,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#1A1818",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#1A1818",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Raleway", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#1A1818",
  descriptionFontSize: 14,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Raleway", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 25,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 50,
  checkboxUncheckedBorderColor: "#96999C",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#F96E11",
  checkboxCheckedBorderColor: "#96999C",
  checkboxCheckedColor: "#FFFFFF",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Raleway", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#1A1818",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 25,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#96999C",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#F96E11",
  radioCheckedBorderColor: "#96999C",

  radioAlignment: "none",

  radioLabelFontFamily: '"Raleway", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#1A1818",

  // **********************************
  // submit button

  submitMarginTop: 40,
  submitFontSize: 15,
  submitFontFamily: "'Raleway', sans-serif",
  submitWidth: 190,
  submitWidthUnits: "px",
  submitHeight: 45,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#F96E11",
  submitColor: "#FFFFFF",
  submitBorderColor: "#F96E11",
  submitBackgroundHover: "#F96E11",
  submitBorderColorHover: "#F96E11",
  submitColorHover: "#FFFFFF",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  